module.exports = "<div>\r\n\t<h1>SmartEEs Showroom</h1>\r\n\t<p>Discover more than 35 flexible electronics technologies that could help you in making real your product ideas</p>\r\n</div>\r\n\r\n<showroom-mat-card-view *ngFor=\"let showroomMatCardViewModel of viewModel.showroomMatCardViewModels\" id=\"{{showroomMatCardViewModel.technologyCategoryName}}\" [viewModel]=\"showroomMatCardViewModel\"></showroom-mat-card-view>\r\n"


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app/components/home/showroom/showroom.component.html
// module id = ./Frontend/src/app/components/home/showroom/showroom.component.html
// module chunks = main